@if(setting.active !== false) {
    <!-- SettingContainer -->
    @if (setting.settings) {
    <p-panel header="{{setting.label | hisUi}}" [title]="title">
        @for (childSetting of setting.settings; track childSetting) {
            <his-job-setting [setting]="childSetting"></his-job-setting>
        }
    </p-panel>
    }
    <!-- Setting -->
    @switch (setting.type) {
       @case ('INTEGER') {
           <his-integer-job-setting [setting]="setting" />
       }
       @case ('DOUBLE') {
           <his-double-job-setting [setting]="setting" />
       }
       @case ('SHORT_TEXT') {
           <his-short-text-job-setting [setting]="setting" />
       }
       @case ('LONG_TEXT') {
           <his-long-text-job-setting [setting]="setting" />
       }
       @case ('HTML_TEXT') {
           <his-html-text-job-setting [setting]="setting" />
       }
       @case ('SELECT_ONE') {
           <his-select-one-job-setting [setting]="setting" />
       }
       @case ('SELECT_MANY') {
           <his-select-many-job-setting [setting]="setting" />
       }
       @case ('BOOLEAN') {
           <his-boolean-job-setting [setting]="setting" />
       }
       @case ('DATE') {
           <his-date-job-setting [setting]="setting" />
       }
       @case ('FILE') {
           <his-file-job-setting [setting]="setting" />
       }
       @case ('SETTING_GROUP') {
           @for (childSetting of setting.childSettings; track childSetting) {
               @if(childSetting.type !== 'CUSTOM_SETTING_GROUP') {
                   <his-job-setting [setting]="childSetting" />
               }
           }
       }
       @case ('CUSTOM_SETTING_GROUP') {
           @for (childSetting of setting.childSettings; track childSetting) {
               <his-job-setting [setting]="childSetting" />
           }
       }
       @default { }
    }
}
